import Tcb from '@/tcb'
const Policy = {
  data: () => ({
    loading: true,
    list: [],
    total: 0,
    skip: 0,
    paginationLength: 0,
    pagination: false
  }),
  methods: {
    async input (page) {
      this.skip = page - 1
      await this.getPolicy()
    },
    async getPolicy () {
      const limit = 10
      const db = Tcb.database()
      this.loading = true
      try {
        const query = db.collection('policy_statute').orderBy('_createTime', 'desc').orderBy('order', 'desc').skip(this.skip * limit).limit(limit)
        const reqArr = [query.get()]
        if (!this.total) {
          reqArr.push(query.count())
        }
        const res = await Promise.all(reqArr)
        // console.log('news', res)
        if (res[1]) {
          this.total = res[1].total
          if (this.total > this.limit) {
            this.pagination = true
            this.paginationLength = this.total
          }
        }
        if (res[0].data.length > 0) {
          this.$set(this.list, this.skip, res[0].data.map(item => {
            const { _id, datetime: date, title } = item
            return {
              id: _id,
              date: new Date(date),
              title
            }
          }))
          console.log(this.list)
        }
      } catch (error) {
        // console.log(error)
      }
      this.loading = false
    },
    itemOnClick (item) {
      // console.log(item)
      this.$router.push({
        path: `policy-statute/${item.id}`
      })
    }
  }
}
export {
  Policy
}
